/**
 * @fileoverview Input/output schemas for character-arc-creation-v2.
 *
 * This agent generates a detailed developmental arc for a single character.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { CharacterPlannedArcV2Schema } from '@/domains/characters/schemas';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Full input for the agent flow.
 */
export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.seriesContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldElements.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.activeCharacterContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
  isShortForm: z.boolean().optional().describe(
    'When true, the project is short-form (single chapter, <7,500 words). ' +
    'The agent should produce only arcName and arcSummary with an empty beats array.'
  ),
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  plannedCharacterArc: CharacterPlannedArcV2Schema,
});

export type Output = z.infer<typeof OutputSchema>;
